import { ShieldCheck } from "lucide-react";

const items = [
  "CP PLUS AUTHORIZED PRO",
  "HIKVISION 4K NIGHT VISION",
  "5.0★ GOOGLE RATING — 70 REVIEWS",
  "SAME-DAY INSTALLATION",
  "BIOMETRIC ACCESS CONTROL",
  "VIDEO DOORBELLS & ELECTRIC LOCKS",
  "1-YEAR ON-SITE WARRANTY",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section className="relative border-y border-line bg-alt py-6 overflow-hidden" data-testid="marquee-section">
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-8 pr-8 shrink-0">
            <span className="font-display font-bold text-sm sm:text-base tracking-[0.12em] text-soft whitespace-nowrap">
              {item}
            </span>
            <ShieldCheck className="w-4 h-4 text-cyan-500/60 shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}
